export const cohortComparisonMessages = {
  TITLE: 'New Cohort Comparison',
  SAVE: 'Create New Comparison',
  CREATE: 'Add Analysis',
  UPDATE: 'Update Analysis',
  ANOTHER: 'Add Another Cohort',
  ADD: 'Add Cohort',
  CANCEL: 'No, Proceed',
  PREVIEW: 'Preview Cohorts Selected',
  EDIT: 'Edit Cohorts Selected',
  NEW: 'New Comparison',
  NAME: 'Comparison Name',
  NAME_PLACEHOLDER: 'Enter Comparison Name',
  COHORT: 'Enter Cohort Name And Select Its Corresponding Color',
  COHORT_PLACEHOLDER: 'Enter Cohort Name',
  CREATE_NEW: 'Do you want to create another cohort?',
  PROCEED: 'Proceed to Trend',
  DEFAULT_PRIMARY_AXIS_DATA: {
    unit: 'Cost',
    chartType: 'Line',
    metrics: [
      {
        name: 'Overall Cost Trend',
        identifier: 'overall',
        options: [
          {
            name: 'Total Cost of Care',
            color: '#ff8c8c',
          },
        ],
      },
    ],
    chartStyle: 'Solid Line',
  },
  CHART_STYLE: 'Line Chart Type',
  STYLE_OPTIONS: ['Dotted Line', 'Dashed Line', 'Solid Line'],
  NEW_TREND: 'Add Trend',
  TREND_NAME: 'Trend Name',
  ANOTHER_TREND: 'Do you want to create another trend?',
  TREND_PLACEHOLDER: 'Enter Trend Name',
  TREND_PREVIEW: 'Preview Trends',
  CREATE_ANALYSIS: 'Create Analysis',
  UPDATE_ANALYSIS: 'Update Analysis',
  EDIT_ANALYSIS: 'Edit Analysis',
};
